export enum EBIStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  RE_PROCESSING = 'RE_PROCESSING',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  DONE = 'DONE',
}
